import { gql } from "@apollo/client";
import StackedAvatars from "atoms/StackedAvatars";
import { HOME_AWAY_TEAM_COLORS, TEAM_COLORS } from "helpers/colors";
import React from "react";

import PlayerAvatar from "../atoms/PlayerAvatar";
import EventMarker, { EventMarkerFragment } from "./EventMarker";

export const EventAvatarFragment = gql`
  fragment EventAvatarFragment on Event {
    isPlayerEvent
    playerNumber
    teamColor
    isHomeTeamEvent
    ...EventMarkerFragment
  }
  ${EventMarkerFragment}
`;

export default function EventAvatar({
  event,
  size = 16,
  active = false,
  inverse = false,
  useHomeAwayTeamColors = false,
  ...others
}) {
  if (!event?.isPlayerEvent)
    return <EventMarker size={size} event={event} active={active} inverse={inverse} {...others} />;

  const teamColor = useHomeAwayTeamColors
    ? HOME_AWAY_TEAM_COLORS[event?.isHomeTeamEvent ? "home" : "away"]
    : TEAM_COLORS[event?.teamColor];

  return (
    <StackedAvatars
      {...others}
      size={size}
      primaryAvatar={
        <PlayerAvatar
          color={teamColor}
          playerNumber={event?.playerNumber}
          inverse={useHomeAwayTeamColors ? event?.isHomeTeamEvent : inverse}
        />
      }
      secondaryAvatar={<EventMarker event={event} active={active} inverse={inverse} />}
    />
  );
}
